// popup(새 창 이메일 편집기) 식별 유틸.
// store / services / apps 어디서나 import 가능하도록 services 레이어에 둔다.
// window.location.pathname 기반 sync 함수라 모듈 import 시점(myNet 등)에도 안전하다.

export const POPUP_EMAIL_EDITOR_PATH = '/popup/email-editor'

export function isPopupMode(): boolean {
  return window.location.pathname === POPUP_EMAIL_EDITOR_PATH
}
